/* import __COLOCATED_TEMPLATE__ from './vertical-radio-button-group-button.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */

import templateOnly from '@ember/component/template-only';
const PulseCandidateVerticalRadioButtonGroupButtonComponent = templateOnly();
export default PulseCandidateVerticalRadioButtonGroupButtonComponent;